import React, { FC, Dispatch, SetStateAction, MouseEvent } from "react"
import style from "./CompleteConsentsMainText.module.scss"
import { getDocsByClientSource } from "../../utils/getDocsByClientSource"
import { brand } from "../../consts/brand"

type CompleteConsentsMainTextProps = {
  setHidden: Dispatch<SetStateAction<boolean>>
}

export const CompleteConsentsMainText: FC<CompleteConsentsMainTextProps> = ({ setHidden }) => {
  const checkSingleConsents = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    setHidden(false)
  }

  return (
    <div className={style.text}>
      Ho preso visione dell&apos;
      <a
        className={style.link}
        target="_blank"
        href={getDocsByClientSource().informativaPrivacy}
        rel="noopener noreferrer"
      >
        Informativa
      </a>{" "}
      e acconsento al trattamento dei miei dati per finalità di marketing, profilazione e comunicazione dei dati a
      partner di {brand.name}.{" "}
      <button className={style.link} onClick={checkSingleConsents}>
        Clicca qui
      </button>{" "}
      per selezionare i singoli consensi.
    </div>
  )
}
